export const jobDocumentKeys = {
    all: ['job-documents'] as const,
    lists: (jobId: string) => [...jobDocumentKeys.all, jobId, 'list'] as const,
    list: (jobId: string, filters: Record<string, unknown> = {}) =>
        [...jobDocumentKeys.lists(jobId), filters] as const,
}
